module.exports = __webpack_public_path__ + "img/team2.ac3ee933.png";